export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total à débiter"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commission"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["À créditer"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de calculer le montant"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fonds insuffisants pour le paiement"])}
}